import { IEventTreeData, IPositional, Semantics } from './event-tree.class';

export class InitializeEventTreeInstance {
    public static readonly type = '[EventTree] InitializeEventTreeInstance';
    constructor(
        public gameId: string,
        public applicationId: number
    ) {}
}

export class StartEventTreeService {
    static readonly type = '[EventTree] StartEventTreeService';
    constructor(
        public eventData?: IEventTreeData
    ) {}
}

export class SelectEventTreeItem {
    static readonly type = '[EventTree] SelectEventTreeItem';
    constructor(
        public event: IPositional
    ) {}
}

export class SetEventTreeValue {
    static readonly type = '[EventTree] SetEventTreeValue';
    constructor(public semantics: Semantics, public value: string | undefined) {}
}

export class SaveEventTreeData {
    static readonly type = '[EventTree] SaveEventTreeData';
}

export class EventTreeBackNavigation {
    static readonly type = '[EventTree] EventTreeBackNavigation';
}

export class SetEventTreeError {
    static readonly type = '[EventTree] SetEventTreeError';
    constructor(public error: string | undefined) {}
}
